import type { XYChartRectSeriesProps } from '../types/xy-chart.js';

export const RectSeries = (props: XYChartRectSeriesProps) => null;

RectSeries['displayName'] = 'XYChart.RectSeries';
